import { render, staticRenderFns } from "./LeadsMatchList.vue?vue&type=template&id=1b1bb3a0"
import script from "./LeadsMatchList.vue?vue&type=script&lang=js"
export * from "./LeadsMatchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports